import { useEffect } from 'react';
import DialogConfirm from 'common/ui/DialogConfirm';
import { useFieldsDispatch, useFieldsState } from 'domains/reporter/Reporter/Fields/Fields.Context';
import { moveSelectionToFirstEmptyRequiredField } from 'domains/reporter/RichTextEditor/utils';
import { EmptyRequiredFieldsDialogContent } from 'domains/reporter/RichTextEditor/plugins/requiredFields/components/EmptyRequiredFieldsDialogContent';
import { DEFAULT_FIELDS_WARNING_MODAL_PROPS } from './constants';
import { useSlateStatic } from 'domains/reporter/RichTextEditor/core';
import { useEmptyRequiredFieldsDialog } from '../useEmptyRequiredFieldsDialog';

export const RequiredFieldsEnforcement = (): React.ReactElement => {
  const editor = useSlateStatic();
  const { worklistItem } = useFieldsState();
  const { getCurrentReportContent } = useFieldsDispatch();
  const {
    state: emptyRequiredFieldsDialogState,
    isOpenForCurrentCase,
    close: closeEmptyRequiredFieldsDialog,
    clearIfOwnedByWorklistItem,
  } = useEmptyRequiredFieldsDialog(worklistItem.smid);

  // Clear required-field dialog state when this case unmounts so stale modal content
  // from a discarded or replaced case cannot remain visible on the next case.
  useEffect(() => {
    const worklistItemSmid = worklistItem.smid;

    return () => {
      clearIfOwnedByWorklistItem(worklistItemSmid);
    };
  }, [clearIfOwnedByWorklistItem, worklistItem.smid]);

  const handleCloseEmptyRequiredFieldsDialog = () => {
    closeEmptyRequiredFieldsDialog();

    if (editor != null) {
      moveSelectionToFirstEmptyRequiredField(getCurrentReportContent(), editor);
    }
  };

  return (
    <DialogConfirm
      {...DEFAULT_FIELDS_WARNING_MODAL_PROPS}
      open={isOpenForCurrentCase}
      slug="required-fields-enforcement-dialog"
      onConfirm={handleCloseEmptyRequiredFieldsDialog}
      confirmText={
        emptyRequiredFieldsDialogState.emptyRequiredFields.length === 1
          ? 'Go to empty required field'
          : 'Go to first empty required field'
      }
      confirmButtonVariant="secondary"
    >
      <EmptyRequiredFieldsDialogContent />
    </DialogConfirm>
  );
};
